import { FeatureFlagsContext } from '@contexts/FeatureFlagsContext';
import { useEvent } from '@event/hooks/useEvent';
import { EventBannerProps, EventTypes } from '@event/types/event';
import { Button, Chip, Tooltip, Typography } from '@mui/material';
import clsx from 'clsx';
import { CSSProperties, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FilePickerModal } from './FilePickerModal';

const EventBanner = ({ isEdit, formik, previewState: { bannerPreview, setBannerPreview } }: EventBannerProps) => {
    const { type, eventId } = useParams();
    const eventType = type as EventTypes;
    const { event } = useEvent(eventType, Number(eventId));
    const { organizers } = useContext(FeatureFlagsContext);

    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <div
                style={
                    {
                        '--banner-url': `url(${
                            bannerPreview ?? event?.banner_image ?? '/static/default-event-banner.svg'
                        })`,
                    } as CSSProperties
                }
                className="relative min-h-96 h-max rounded-lg overflow-hidden bg-cover bg-center bg-[image:var(--banner-url)]"
            >
                <div className="flex justify-between bg-black/50 absolute w-full h-full top-0 left-0 overflow-hidden ">
                    <div className="flex flex-col align-end justify-around gap-11 pl-12 py-10">
                        <Tooltip
                            title={event?.name || ''}
                            placement="top"
                            sx={{
                                '& .MuiTooltip-tooltip': {
                                    fontSize: '1.15rem',
                                    fontWeight: 500,
                                },
                            }}
                        >
                            <Typography
                                className={clsx('max-w-[667px] leading-[58px] line-clamp-4 -mb-1', {
                                    '!line-clamp-3': organizers && event?.organizers?.length,
                                })}
                                color="white"
                                fontWeight={700}
                                fontSize={48}
                            >
                                {event?.name}
                            </Typography>
                        </Tooltip>
                        <div className="flex flex-col gap-2 font-roboto font-medium w-min min-w-[262px]">
                            <Chip
                                className="font-roboto p-0 text-white bg-gradient-to-r from-primary-700 to-primary-600 px-3 py-1"
                                label={`Event created by: ${event?.owner?.full_name}`}
                            />
                            {organizers && event?.organizers?.length ? (
                                <Chip
                                    className="text-white"
                                    label={`${`Co-organized by: ${event?.organizers
                                        .map((organizer) => organizer.user.full_name)
                                        .join(', ')}`}`}
                                />
                            ) : null}
                        </div>
                    </div>
                    {isEdit && (
                        <>
                            <div className="pt-6 pr-8">
                                <Button
                                    className="rounded-full
                                "
                                    onClick={() => setModalOpen(true)}
                                >
                                    Edit Event Banner
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <FilePickerModal
                open={modalOpen}
                setOpen={setModalOpen}
                formik={formik}
                fileUploadContainerClassName="px-16"
                eventType={eventType}
                eventId={eventId ?? ''}
                setPreview={setBannerPreview}
            />
        </>
    );
};

export { EventBanner };
